import { render, staticRenderFns } from "./Reactions.vue?vue&type=template&id=634e6af9&scoped=true"
import script from "./Reactions.vue?vue&type=script&lang=js"
export * from "./Reactions.vue?vue&type=script&lang=js"
import style0 from "./Reactions.vue?vue&type=style&index=0&id=634e6af9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634e6af9",
  null
  
)

export default component.exports